import LoginForm from "@/auth/components/LoginForm";
import RegistrationForm from "@/auth/components/RegistrationForm";
import { useAuth } from "@/auth/hooks/useAuth";
import { isPureFunder } from "@/auth/roleAccess";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import useCheckIsDevice from "@/hooks/useDeviceType";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Auth = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();
  const isMobile = useCheckIsDevice("mobile");

  useEffect(() => {
    if (!isAuthenticated || !user?.isVerified) {
      return;
    }

    if (isPureFunder(user)) {
      return;
    }

    if (user?.status === 1) {
      navigate(`/dashboard`, { replace: true });

      return;
    }

    /*else if (redirect) {
      window.location.href = redirect;
    } */
    navigate(`/submit/programs`, { replace: true });
  }, [isAuthenticated, navigate, user]);

  if (isAuthenticated && user?.isVerified && !isPureFunder(user)) {
    return null;
  }

  if (loading)
    return (
      <div className="container min-h-screen">
        <LoadingSpinner />
      </div>
    );
  //Todo: Rédirection de l'utilisateur vers la page code s'il n'est pas vérifié et on lui envoie un code mail
  return (
    <div className="container">
      {isMobile ? (
        <Tabs defaultValue="login" className="w-full">
          <TabsList className="mb-2 grid w-full grid-cols-2">
            <TabsTrigger value="login">Connexion</TabsTrigger>          </TabsList>
          <TabsContent value="login" className="mb-4">
            <LoginForm />
          </TabsContent>
          <TabsContent value="registration" className="mb-4">
            <RegistrationForm />
          </TabsContent>
        </Tabs>
      ) : (
        <div className="mx-auto mb-5 mt-8 flex justify-center lg:w-3/4">
          <div className="w-full md:w-1/2 px-4">
            <LoginForm />
          </div>
        </div>
      )}
    </div>
  );
};

export default Auth;
